module.exports = __webpack_public_path__ + "static/adesanya-78b51fb79dd0b52e26ef7cd89bfa3c55.png";